/**
 * Blog Posts Configuration
 *
 * Simply add your markdown file URLs to this array.
 * The system will automatically extract all metadata from the markdown frontmatter.
 *
 * Make sure your markdown files include proper frontmatter (see BLOG_SETUP.md for details)
 */

export const BLOG_POST_URLS = [
  // Local markdown files (stored in public/blog_posts_in_markdown/)

  '/blog_posts_in_markdown/2025.07.30 - Software contable.md',

  '/blog_posts_in_markdown/2025.07.31 - Integrar IA en tu negocio.md',

  '/blog_posts_in_markdown/2025.08.15 - AI 2027.md',

  '/blog_posts_in_markdown/2025.08.16 - Contadores sin IA.md',

  '/blog_posts_in_markdown/2025.08.17 - Empresarios le temen.md',

  // Add more local markdown files here:
  // '/blog_posts_in_markdown/my-second-post.md',
  // '/blog_posts_in_markdown/my-third-post.md',

  // Example: External URLs (if needed)
  // 'https://raw.githubusercontent.com/your-username/your-blog-repo/main/posts/my-new-post.md',
];

/**
 * CORS Proxy Configuration (if needed)
 *
 * Only needed for external URLs that don't allow cross-origin requests.
 * Local files (starting with '/') don't need CORS proxies.
 *
 * Popular options:
 * - 'https://cors-anywhere.herokuapp.com/'
 * - 'https://api.allorigins.win/raw?url='
 * - Your own CORS proxy
 */
export const CORS_PROXY = '';

/**
 * Cache Configuration
 *
 * How long to cache blog posts in milliseconds
 * Set to 0 to disable caching
 */
export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
